var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "drag-dialog",
              rawName: "v-drag-dialog",
              value: _vm.visible,
              expression: "visible",
            },
          ],
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.$slots.title
        ? _c(
            "div",
            {
              staticClass: "flex flex-align-center",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._t("title")],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            "max-height": "67vh",
            "overflow-y": "auto",
            "overflow-x": "hidden",
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm.$slots.footer
        ? _c(
            "div",
            { staticClass: "flex-center footer padding-top-10" },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }